// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPricesV4Schema {
  /** Комиссия риелтора **/
  agentBonusPayment?: string;
  /** Залог **/
  deposit?: string;
  /** Подготовленная строка с ценой за объект (11, 6 млн ₽) **/
  price: string;
  /** Разность между ценой при подаче и ценой при снятии **/
  priceDiff: EPriceDiff;
  /** Подготовленная строка с ценой за кв.м. (120 000 ₽ / м2) **/
  priceSqm?: string;
}

export enum EPriceDiff {
  /** Цена уменьшилась **/
  'Decrease' = 'decrease',
  /** Цена увеличилась **/
  'Increase' = 'increase',
  /** Цена не изменилась **/
  'NoChange' = 'noChange',
}
